import { render, staticRenderFns } from "./ESV.vue?vue&type=template&id=65f63b6e&scoped=true&"
import script from "./ESV.vue?vue&type=script&lang=js&"
export * from "./ESV.vue?vue&type=script&lang=js&"
import style0 from "./ESV.vue?vue&type=style&index=0&id=65f63b6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f63b6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems})
